import { render, staticRenderFns } from "./cpt-iframe-option.vue?vue&type=template&id=705cc03a&scoped=true"
import script from "./cpt-iframe-option.vue?vue&type=script&lang=js"
export * from "./cpt-iframe-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705cc03a",
  null
  
)

export default component.exports